import router from "./routers";
import {
  getToken
} from "../utils/auth";
import SysUtils from "@/utils/sysUtils";

const whiteList = ['404', 'login', 'wxAuth', 'agreement','agreement-dabenying','agreement-bopeng','agreement-jiajiuhui','agreement-boxing','agreement-fuqi','agreement-beifu','agreement-cehao','agreement-baoleqi', 'maintain']; // 路由白名单，这些路由不做校验，可直接访问

/**
 * 全局前置守卫：路由拦截器
 */
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  let access = whiteList.some((ele) => {
    return ele == to.name;
  });
  if (access) {
    next();
  } else {
    // 如果token不存在或token已经过期，重新登录
    if (!getToken()) {
      // 如果是微信环境，先跳转到微信授权登录页进行登录，微信授权登录后，如果没有绑定手机号会再跳转到login页
      // 如果不是微信环境，直接跳转到login页
      if (SysUtils.isWeiXin()) {
        next({
          path: "/wxAuth"
        })
      } else {
        next({
          path: "/login"
        })
      }
    } else {
      next();
    }
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js